import Cookie from 'js-cookie'
const state = {
    userInfo:Cookie.get('userInfo'),
    loginState:0,
    loginToken:''
}
const mutations = {
    setUserInfo:(state,data)=>{
        data = JSON.stringify(data);
        state.userInfo = data;
        console.log('state.userInfo',state.userInfo)
        Cookie.set('userInfo',data);
    },
    setLoginState(state,data){
        state.loginState = data;
        Cookie.set('loginState',data);
    }
}
export default {
    namespaced:true,
    state,
    mutations
}